<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table :headers="headers" :items="liquidacioneselect" :search="search" class="elevation-1">
                <template v-slot:top>
                    <v-toolbar color="white">
                        <v-toolbar-title><v-icon>calendar_month</v-icon></v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda"
                            single-line hide-details></v-text-field>
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialog" max-width="800px">
                           
                            <v-card>
                                <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <v-alert  type="info">
                                                    Parametros
                                                </v-alert>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12">
                                                        <v-text-field v-model="parametronombre" label="Nombre del Parametro"
                                                            outlined></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12">
                                                        <v-text-field v-model="parametrovalor" label="Valor del Parametro"
                                                            outlined></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12">
                                                <v-dialog ref="dialog1" v-model="modal1" :return-value.sync="fecha1"
                                                    persistent width="290px">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field v-model="fecha1" :readonly="fecha1 == 1"
                                                            label="Fecha de Inicio" prepend-icon="event" v-bind="attrs"
                                                            v-on="on" solo @click="listar()"></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="fecha1" scrollable locale="es-es"
                                                        :readonly="fecha1 == 1">
                                                        <v-spacer></v-spacer>
                                                        <v-btn text color="primary" @click="modal1 = false">Cancelar</v-btn>
                                                        <v-btn text color="primary"
                                                            @click="$refs.dialog1.save(fecha1), listar()">OK</v-btn>
                                                    </v-date-picker>
                                                </v-dialog>
                                            </v-col>

                                            
                                            <v-col cols="12" sm="12" md="12" v-show="valida">
                                                <v-row class="red--text" v-for="v in validamensaje" :key="v"
                                                    v-text="v"></v-row>
                                            </v-col>

                                        </v-row>
                                    </v-container>
                                </v-card-text>

                                <div class="text-center">
                                    <v-btn class="mx-2" fab dark large @click="close">
                                        <v-icon dark> close </v-icon>
                                    </v-btn>
                                    <v-btn class="mx-2" fab dark large @click="guardar" v-if="guardarvisible === 1">
                                        <v-icon dark> save </v-icon>
                                    </v-btn>
                                </div>

                            </v-card>
                        </v-dialog>

                        
                    </v-toolbar>
                </template>
                <template v-slot:item.action="{ item }">
                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <v-icon dense class="mr-2" @click="ver(item)" v-on="on">remove_red_eye</v-icon>
                        </template>
                        <span>Ver Parametro</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <v-icon dense class="mr-2" @click="editar(item)" v-on="on">edit</v-icon>
                        </template>
                        <span>Editar Parametro</span>
                    </v-tooltip>

                </template>
                <template v-slot:no-data>
                    <v-btn color="primary" @click="listar">Reset</v-btn>
                </template>

                <template v-slot:item.parametroestatus="{ item }">
                    <v-chip :color="getColor(item.parametroestatus)" dark v-if="item.parametroestatus == 1">ACTIVO</v-chip>
                    <v-chip :color="getColor(item.parametroestatus)" dark
                        v-if="item.parametroestatus == 2">SUSPENDIDO</v-chip>
                </template>

                <template v-slot:item.parametrofecha="{ item }">
                    <p>{{ getHumanDate(item.parametrofecha) }}</p>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    data() {
        return {
            // Variable categoria
            tipooperaciones: [],
            dialog: false,
            headers: [
                { text: "Accion", value: "action", sortable: false },
                { text: "ParametroID", value: "parametroid" },
                { text: "Nombre", value: "parametronombre" },
                { text: "Fecha", value: "parametrofecha" },
                { text: "Estatus", value: "parametroestatus" }
            ],

            liquidacionturnoselect: [
                { text: "TURNO 1", value: 1 },
                { text: "TURNO 2", value: 2 },
                { text: "TURNO 3", value: 3 }
            ],

            liquidacionislaselect: [
                { text: "ISLA 1", value: 1 },
                { text: "ISLA 2", value: 2 },
                { text: "ISLA 3", value: 3 }
            ],


            liquidacionnombreselect: [],
            liquidacioneselect:[],


            search: "",
            editedIndex: -1,
            //Declaracion de varaibles
            liquidacionid:"",
            liquidacionnombre: "",
            liquidacionturno: "",
            liquidacionisla: "",
            guardarvisible: 0,
            liquidacionnombrecompleto: "",
            fecha1: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),

            modal1: false,


            // Declara variables de Validacion
            valida: 0,
            validamensaje: [],
            vehiculoselect: [],
            gasolinatiposelect: [],

            // Declara Varaiables para activar o desactivar categorias
            adModal: 0,
            adAccion: 0,
            adNombre: "",
            adId: "",
            parametronombre:"",
            parametroid:"",
            parametrovalor:"",
        };
    },
    // Crea una nueva categoria si es -1
    computed: {
        formTitle() {
            return this.editedIndex === -1
                ? "Nuevo Parametro"
                : "Actualizar Parametro";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    created() {
        this.listar();
        this.selectusuarios();
    },

    //
    methods: {
        getHumanDate: function (date) {
            return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
        },

        // metodo listar
        listar() {
            // Variable para cargar los datos del api
            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            // Manda llamar al listado e catalogos
            axios
                .get("api/parametros/listar", configuracion)
                .then(function (response) {
                    me.liquidacioneselect = response.data.parametro;
                })
                .catch(function (error) {
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },

        // metodo listar
        selectusuarios() {
            let me = this;
            var listaArray = [];
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            axios
                .get("api/usuarios/listar", configuracion)
                .then(function (response) {
                    listaArray = response.data.usuarios;
                    listaArray.map(function (x) {
                        me.liquidacionnombreselect.push({
                            text: x.usuarionombre,
                            value: x.usuarionombre,
                        });
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },

        liquidanombre(){

        },

        // Color
        getColor(socioestatus) {
            if (socioestatus == 1) return "#3F8103";
            if (socioestatus == 2) return "red";
        },

        // Actualiza la categotia
        editar(item) {
            this.parametroid=item.parametroid;
            this.parametronombre=item.parametronombre;
            this.fecha1=item.parametrofecha;
            this.parametrovalor=item.parametrovalor;
            this.editedIndex = 1;
            this.guardarvisible = 1;
            this.dialog = true;
        },

        // Actualiza la categotia
        ver(item) {
            
            this.parametronombre=item.parametronombre;
            this.fecha1=item.parametrofecha;
            this.parametrovalor=item.parametrovalor;
            this.editedIndex = 1;
            this.guardarvisible = 0;
            this.dialog = true;
        },

        close() {
            this.dialog = false;
            this.guardarvisible = 0;
            this.limpiar();
        },

        limpiar() {
            this.liquidacionid="";
            this.liquidacionnombre="";
            this.liquidacionturno="";
            this.liquidacionisla="";
            this.parametrovalor="";
            this.fecha1=moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD");
            this.guardarvisible=1;
            this.dialog=0;
        },

        // Select
        selectvehiculos() {
            let me = this;
            var listaArray = [];
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            axios
                .get("api/vehiculos/listarvehiculos", configuracion)
                .then(function (response) {
                    listaArray = response.data.vehiculo;
                    listaArray.map(function (x) {
                        me.vehiculoselect.push({
                            text: x.vehiculonombre,
                            value: x.vehiculoid,
                        });
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },

        listarvehiculoid() {
            let me = this;
            var listaArray = [];
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            axios
                .get(
                    "api/vehiculos/listarvehiculosfechaid/" + this.vehiculoid,
                    configuracion
                )
                .then(function (response) {
                    listaArray = response.data.vehiculo;
                    me.vehiculocarganormal = response.data.vehiculo.vehiculocarganormal;
                    me.vehiculocargaadicional =
                        response.data.vehiculo.vehiculocargaadicional;
                    me.vehiculocargaexcepcion =
                        response.data.vehiculo.vehiculocargaexcepcion;
                    me.vehiculofechacarga = response.data.vehiculo.vehiculofechacarga;
                    me.vehiculofechacargavence =
                        response.data.vehiculo.vehiculofechacargavence;
                    me.vehiculolibresino = response.data.vehiculo.vehiculolibresino;
                    //
                    me.vehiculodotacionnormal =
                        response.data.vehiculo.vehiculodotacionnormal;
                    me.vehiculodotacionadicional =
                        response.data.vehiculo.vehiculodotacionadicional;
                    me.vehiculodotacionexcepcion =
                        response.data.vehiculo.vehiculodotacionexcepcion;
                    //

                    if (me.vehiculolibresino == 1) {
                        me.vehiculocarganormalresta = 0;
                        me.vehiculocargaadicionalresta = 0;
                        me.vehiculocargaexcepcionresta = 0;
                    } else {
                        me.vehiculocarganormalresta = (parseFloat(me.vehiculodotacionnormal) - parseFloat(me.vehiculocarganormal)).toFixed(2);
                        me.vehiculocargaadicionalresta = (parseFloat(me.vehiculodotacionadicional) - parseFloat(me.vehiculocargaadicional)).toFixed(2);
                        me.vehiculocargaexcepcionresta = (parseFloat(me.vehiculodotacionexcepcion) - parseFloat(me.vehiculocargaexcepcion)).toFixed(2);

                    }

                    //
                    me.gasolinacarga = "";
                    me.gasolinatipo = "";

                    if (
                        parseFloat(me.vehiculocarganormal) <=
                        parseFloat(response.data.vehiculo.vehiculodotacionnormal) &&
                        parseFloat(me.vehiculocargaadicional) == 0 &&
                        parseFloat(me.vehiculocargaexcepcion) == 0 &&
                        me.vehiculolibresino == 2
                    ) {
                        me.tipodecargaid = "1";
                    }

                    if (
                        parseFloat(me.vehiculocarganormal) ==
                        response.data.vehiculo.vehiculodotacionnormal &&
                        parseFloat(me.vehiculocargaadicional) <=
                        parseFloat(response.data.vehiculo.vehiculodotacionadicional) &&
                        parseFloat(me.vehiculocargaexcepcion) == 0 &&
                        me.vehiculolibresino == 2
                    ) {
                        me.tipodecargaid = "2";
                    }

                    if (
                        parseFloat(me.vehiculocarganormal) ==
                        parseFloat(response.data.vehiculo.vehiculodotacionnormal) &&
                        parseFloat(me.vehiculocargaadicional) ==
                        parseFloat(response.data.vehiculo.vehiculodotacionadicional) &&
                        parseFloat(me.vehiculocargaexcepcion) >= 0 &&
                        me.vehiculolibresino == 2
                    ) {
                        me.tipodecargaid = "3";
                    }

                    if (me.vehiculolibresino == 1) {
                        me.tipodecargaid = "4";
                    }
                    me.gasolinatipo = 1;
                    me.listarcombustibleid();
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },

        listarcombustibleid() {
            let me = this;
            var listaArray = [];
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            axios
                .get(
                    "api/combustibles/listarcombustiblesid/" + me.gasolinatipo,
                    configuracion
                )
                .then(function (response) {
                    listaArray = response.data.combustible;
                    me.gasolinacosto = response.data.combustible.combustiblecosto;
                    me.gasolinacarga = parseFloat(me.gasolinalitros) * parseFloat(me.gasolinacosto)

                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },

        calculalitros() {
            if (this.gasolinalitros == "") {
                this.$swal("No a Capturado los Litros del Vehiculo");
                return;
            }

            if (this.gasolinacosto == "") {
                this.$swal("No a Seleccionado el Tipo");
                return;
            }

            this.gasolinacarga = (parseFloat(this.gasolinalitros) * parseFloat(this.gasolinacosto)).toFixed(2);
        },

        // Select
        selectgasolinatipo() {
            let me = this;
            var listaArray = [];
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            axios
                .get("api/combustibles/listarcombustibles", configuracion)
                .then(function (response) {
                    listaArray = response.data.combustible;
                    listaArray.map(function (x) {
                        me.gasolinatiposelect.push({
                            text: x.combustiblenombre,
                            value: x.combustibleid,
                        });
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },

        guardar() {
        
            this.guardarvisible = 0;

            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            let me = this;
            axios
                .post(
                    "api/parametros/actualizar",
                    {
                        parametroid: me.parametroid,
                        parametronombre: me.parametronombre,
                        parametrofecha: me.fecha1,
                        parametrovalor:me.parametrovalor,
                        usuarioid: me.$store.state.usuario.usuarioid
                    },
                    configuracion
                )
                .then(function (response) {
                    me.limpiar();
                    me.listar();
                    me.$swal("Parametro Actualizado con Exito");
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });

            
        },

        validar() {
            this.valida = 0;
            this.validamensaje = [];

            if (!this.vehiculoid) {
                this.validamensaje.push("Vehiculo Vacio");
            }
            if (!this.gasolinacarga) {
                this.validamensaje.push("Importe de Carga Vacio");
            }
            if (!this.gasolinatipo) {
                this.validamensaje.push("Tipo de Gasolina Vacio");
            }

            if (this.validamensaje.length) {
                this.valida = 1;
            }
            return this.valida;
        },

        ActivarDesactivarMostrar(accion, item) {
            this.adModal = 1;
            this.adNombre = item.gasolinaid;
            this.gasolinaid = item.gasolinaid;
            if (accion == 1) {
                this.adAccion = 1;
            } else if (accion == 2) {
                this.adAccion = 2;
            } else {
                this.adModal = 0;
            }
        },
        activarDesactivarCerrar() {
            this.adModal = 0;
        },
        activar() {
            var qs = require("qs");
            var data = qs.stringify({
                json: '{"gasolinaestatus":"1"}',
            });

            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            axios
                .put(
                    "api/gasolinas/activargasolinas/" + this.gasolinaid,
                    data,
                    configuracion
                )
                .then(function (response) {
                    me.adModal = 0;
                    me.adAccion = 0;
                    me.adNombre = "";
                    me.adId = "";
                    me.listar();
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },
        desactivar() {
            var qs = require("qs");
            var data = qs.stringify({
                json: '{"gasolinaestatus":"2"}',
            });
            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            axios
                .put(
                    "api/gasolinas/activargasolinas/" + this.gasolinaid,
                    data,
                    configuracion
                )
                .then(function (response) {
                    me.adModal = 0;
                    me.adAccion = 0;
                    me.adNombre = "";
                    me.adId = "";
                    me.listar();
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },
    },
};
</script>